module.exports = __webpack_public_path__ + "img/arrows-green.58319e28.png";